import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Document} from "../../../shared/interface/document";
import {Mailing} from "../../../shared/interface/mailing";
import {ActivatedRoute} from "@angular/router";
import {DocumentService} from "../../../shared/services/document.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MailingService} from "../../../shared/services/mailing.service";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-email-send-details',
  templateUrl: './email-send-details.component.html',
  styleUrls: ['./email-send-details.component.scss']
})
export class EmailSendDetailsComponent implements OnInit, OnDestroy {
private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  malingId: string;
  mailingObject?: Mailing;
  mailing: ReplaySubject<Mailing> = new ReplaySubject<Mailing>(1);

  constructor(
    private route: ActivatedRoute,
    private mailingService: MailingService,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.malingId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  load(): void {
    this.mailingService.get(this.malingId).subscribe((mailing: Mailing) => {
      this.mailing.next(mailing);
      this.mailingObject = mailing;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych dokumentu', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
